export const ACTIE_TEMPLATE_HELP_BUTTON = 'actie-template-help-button';
export const HELP_CONTEXT_ITEM = 'helpContextItem';
export const HELP_CONTEXT_ITEM_LINK = 'helpContextItemLink';
